import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import GenericSelection from '../Common/GenericSelection';
import { SALES_ORDER_DROPDHIP_URL } from '../../actions/url';

const propTypes = {
  salesOrderId: PropTypes.string.isRequired,
  vendors: PropTypes.array,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

const defaultProps = {
  vendors: [],
};

const styles = {
  modal: {
    width: '300px',
    height: '200px',
    marginLeft: '-15%',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
};

class DropshipModal extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedVendorId: undefined,
      loading: false,
    };
    this.handleSelectVendor = this.handleSelectVendor.bind(this);
    this.createPo = this.createPo.bind(this);
  }

  handleSelectVendor({ value: vendorId }) {
    this.setState({ selectedVendorId: vendorId });
  }

  createPo() {
    const { selectedVendorId } = this.state;
    const { salesOrderId } = this.props;
    if (!selectedVendorId) {
      alert('Please enter a vendor.');
      return;
    }
    this.setState({
      loading: true,
    });
    axios.post(`${SALES_ORDER_DROPDHIP_URL}${salesOrderId}`, {
      vendor_id: selectedVendorId,
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then((response) => {
      const { purchase_order_id } = response.data;
      window.location.pathname = `/purchaseOrder/${purchase_order_id}`;
    }).catch(() => {
      alert('Internal Server Error. Please try again.');
    });
  }

  render() {
    const {
      vendors,
      visible,
      onClose,
    } = this.props;
    const customerOptions = vendors.map(({
      Name,
      Vendor_id,
    }) => ({
      label: Name,
      value: Vendor_id,
    }));
    return (
      <SkyLightStateless
        dialogStyles={styles.modal}
        isVisible={visible}
        onCloseClicked={onClose}
      >
        <div style={styles.container} className="salesOrder-dropship">
          <GenericSelection
            translation={<Translate value="vendor" />}
            setSelected={this.handleSelectVendor}
            value={this.state.selectedVendorId}
            options={customerOptions}
            colon
          />
          <div style={{ marginTop: 50 }}>
            <Button
              bsStyle="primary"
              onClick={this.createPo}
              disabled={this.state.loading}
            >
              <Translate value="create_po" />
            </Button>
          </div>
        </div>
      </SkyLightStateless>
    );
  }
}

DropshipModal.propTypes = propTypes;
DropshipModal.defaultProps = defaultProps;

const mapStateToProps = state => ({
  vendors: state.vendors.all,
});

export default connect(mapStateToProps)(DropshipModal);



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/DropshipModal.jsx